import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css';
import store from "./appState/store";
import SingleProduct from "./pages/SingleProduct";
import RoutePages from "./RoutePages";

const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
    <Provider store={store}>
      <RoutePages />
    </Provider>
);

reportWebVitals();
